/**
 * Utility function to replace template variables with actual data
 * Supports syntax like {{variableName}}
 * Handles variables that may be split across HTML tags
 */
export const replaceTemplateVariables = (content, collectedData = {}) => {
    if (!content || typeof content !== 'string') return content;

    // First, try to fix variables that are split by HTML tags
    // Example: <b>{{nam</b>e}} -> {{name}}
    let cleanedContent = content;

    // Remove HTML tags temporarily to find complete variables
    const textOnly = content.replace(/<[^>]+>/g, '');
    const variableMatches = textOnly.match(/\{\{(\w+)\}\}/g);

    if (variableMatches) {
        variableMatches.forEach(variable => {
            const varName = variable.replace(/[{}]/g, '');
            if (collectedData[varName] !== undefined) {
                // Create a regex that matches the variable even if split by HTML tags
                // This matches {{ followed by the variable name with optional HTML tags in between, followed by }}
                const splitVarRegex = new RegExp(
                    '\\{\\{' +
                    varName.split('').map(char => `${char}(?:<[^>]*>)*`).join('') +
                    '\\}\\}',
                    'gi'
                );
                cleanedContent = cleanedContent.replace(splitVarRegex, collectedData[varName]);
            }
        });
    }

    // Also handle normal, non-split variables
    cleanedContent = cleanedContent.replace(/\{\{(\w+)\}\}/g, (match, variableName) => {
        return collectedData[variableName] !== undefined ? collectedData[variableName] : match;
    });

    return cleanedContent;
};

/**
 * Extract all input variables from screens to build a data collection map
 */
export const extractInputVariables = (screens) => {
    const variables = [];

    if (!screens || !Array.isArray(screens)) return variables;

    screens.forEach((screen, screenIndex) => {
        (screen.elements || []).forEach(element => {
            if (element.type === 'input' && element.variableName) {
                variables.push({
                    variableName: element.variableName,
                    label: element.label || element.variableName,
                    placeholder: element.placeholder,
                    screenIndex,
                    screenName: screen.name || `Screen ${screenIndex + 1}`,
                    elementId: element.id
                });
            }
        });
    });

    return variables;
};
